// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e6a8af40","395":"2b04cd46"}[chunkId] + ".chunk.js";
};